import {
  load as loadFingerprintJs,
  type Agent,
} from '@fingerprintjs/fingerprintjs';

import type { DeviceFingerprintPort } from '~/handlers/ports/device-fingerprint.port';

export class FingerprintJsDeviceFingerprintAdapter
  implements DeviceFingerprintPort
{
  private agentPromise: Promise<Agent> | undefined;

  constructor() {
    if (import.meta.client) {
      this.agentPromise = loadFingerprintJs();
    }
  }

  private getAgent(): Promise<Agent> {
    if (!this.agentPromise) {
      this.agentPromise = loadFingerprintJs();
    }

    return this.agentPromise;
  }

  async generate() {
    if (!import.meta.client) {
      throw new Error(
        '[FingerprintJsDeviceFingerprintAdapter] Fingerprint generation is only available on the client.',
      );
    }

    const agent = await this.getAgent();
    const { visitorId } = await agent.get();

    return visitorId;
  }
}
